import {
  DocumentUploadModalMode,
  DocumentUploadModalNavigationDirection,
} from "../../types/modal";

import styles from "./close-confirmation-modal-view.module.scss";
import { Button } from "@/components/buttons/button";

type CloseConfirmationModalViewProps = {
  onCancel: () => void;
  onConfirm: () => void;
  navigationDirection: DocumentUploadModalNavigationDirection;
  mode: DocumentUploadModalMode;
};

export const CloseConfirmationModalView = ({
  onCancel,
  onConfirm,
  navigationDirection,
  mode,
}: CloseConfirmationModalViewProps) => (
  <>
    <h2
      className={styles.heading}
    >{`Are you sure you want to ${navigationDirection === DocumentUploadModalNavigationDirection.BACK ? "go back" : "exit"}?`}</h2>
    <p className={styles.description}>{"Your changes will not be saved"}</p>
    <div className={styles.actionsContainer}>
      <Button
        onClick={onConfirm}
        variant="primary"
        size="small"
        tone="destructive"
        isFullWidth
      >
        {`${navigationDirection === DocumentUploadModalNavigationDirection.CLOSE ? "Exit" : "Go back"} - changes will be lost`}
      </Button>
      <Button onClick={onCancel} variant="secondary" size="small" isFullWidth>
        {`Continue ${mode === DocumentUploadModalMode.ADD ? "adding" : "editing"} document`}
      </Button>
    </div>
  </>
);
